import BubbleEllipsis from '@/pages/dashboard/components/BubbleEllipsis';
import { useLocal } from '@/pages/dashboard/utils/customHook';

const useComConstants = () => {
  const { isEN, locale, getLocalText } = useLocal();
  const previousActiveHeader = (getLocalText('competitor_insight_competitive_comparison_module1_x_previous') + (isEN ? ' ' : '') + getLocalText('competitor_insight_competitive_comparison_module1_x_lable'))
  const previousRevenueHeader = (getLocalText('competitor_insight_competitive_comparison_module1_x_previous') + (isEN ? ' ' : '') + getLocalText('competitor_insight_competitive_comparison_module1_y_lable'))
  const avgActiveHeader = (getLocalText('competitor_insight_competitive_comparison_module1_avg') + getLocalText('competitor_insight_competitive_comparison_module1_x_lable'))
  const previousAvgActiveHeader = (getLocalText('competitor_insight_competitive_comparison_module1_x_previous') + (isEN ? ' ' : '') + avgActiveHeader)
  const sumRevenueHeader = (getLocalText('competitor_insight_competitive_comparison_module1_sum') + (isEN ? ' ' : '') + getLocalText('competitor_insight_competitive_comparison_module1_y_lable'))
  const previousSumRevenueHeader = (getLocalText('competitor_insight_competitive_comparison_module1_x_previous') + (isEN ? ' ' : '') + sumRevenueHeader)

  const sumNewHeader = getLocalText('competitor_insight_competitive_comparison_module1_sum') + (isEN ? ' ' : '') + getLocalText('competitor_insight_competitive_comparison_module2_x_lable')
  const previousSumNewHeader = getLocalText('competitor_insight_competitive_comparison_module1_x_previous') + sumNewHeader
  const avgD2 = getLocalText('competitor_insight_competitive_comparison_module1_avg') + getLocalText('competitor_insight_competitive_comparison_module2_y_lable')
  const previousAvgD2 = getLocalText('competitor_insight_competitive_comparison_module1_x_previous') + avgD2
  const REVENUE_ACTIVE_COLUMNS = [
    {
      key: 'game',
      header: getLocalText('competitor_key_metrics_performance_game'),
      width: 200,
      align: 'left',
      fixed: 'left',
    },
    {
      key: 'active',
      header: getLocalText('competitor_insight_competitive_comparison_module1_x_lable'),
      align: 'right',
      width: 100,
    },
    {
      key: 'previousActive',
      header: previousActiveHeader,
      align: 'right',
      width: 142,
    },
    {
      key: 'revenue',
      header: getLocalText('competitor_insight_competitive_comparison_module1_y_lable'),
      align: 'right',
      width: 106,
    },
    {
      key: 'previousRevenue',
      header: previousRevenueHeader,
      align: 'right',
      width: 150,
    },
  ];
  const REVENUE_ACTIVE_COLUMNS_SUM = [
    {
      key: 'game',
      header: getLocalText('competitor_key_metrics_performance_game'),
      width: 200,
      align: 'left',
      fixed: 'left',
    },
    {
      key: 'active',
      header: avgActiveHeader,
      align: 'right',
      width: 100,
    },
    {
      key: 'previousActive',
      header: previousAvgActiveHeader,
      align: 'right',
      width: 162,
    },
    {
      key: 'revenue',
      header: sumRevenueHeader,
      align: 'right',
      width: 126,
    },
    {
      key: 'previousRevenue',
      header: previousSumRevenueHeader,
      align: 'right',
      width: 186,
    },
  ];

  const NEW_RETENTION_D2_COLUMNS = [
    {
      key: 'game',
      header: getLocalText('competitor_key_metrics_performance_game'),
      width: 196,
      align: 'left',
      fixed: 'left',
    },
    {
      key: 'new',
      header: sumNewHeader,
      align: 'right',
      width: 80,
    },
    {
      key: 'previousNew',
      header: previousSumNewHeader,
      align: 'right',
      width: 142,
    },
    {
      key: 'D2',
      header: avgD2,
      align: 'right',
      width: 86,
    },
    {
      key: 'previousD2',
      header: previousAvgD2,
      align: 'right',
      width: 136,
    },
  ];
  // 要个气泡提示
  REVENUE_ACTIVE_COLUMNS.forEach((item, index) => {
    REVENUE_ACTIVE_COLUMNS_SUM[index].render = item.render = (t) =>
      t[item.key] === '-' ? (
        '-'
      ) : (
        <BubbleEllipsis content={t[item.key]} maxWidth={item.width - 20} />
      );

    NEW_RETENTION_D2_COLUMNS[index].render = (t) =>
      t[NEW_RETENTION_D2_COLUMNS[index].key] === '-' ? (
        '-'
      ) : (
        <BubbleEllipsis
          content={t[NEW_RETENTION_D2_COLUMNS[index].key]}
          maxWidth={NEW_RETENTION_D2_COLUMNS[index].width - 20}
        />
      );
  });
  return {
    REVENUE_ACTIVE_COLUMNS,
    NEW_RETENTION_D2_COLUMNS,
    REVENUE_ACTIVE_COLUMNS_SUM,
  };
};

export default useComConstants